// SalesChart.js
import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { baseFileURL } from '../../../Api';
import { useTranslation } from 'react-i18next';

function SalesChart({ data }) {
        const { t } = useTranslation();
    
     if (!data || !Array.isArray(data.saler_stat)) {
         return <div>No sales data available</div>;
    }

    let primaryColor = "#000"

    if(baseFileURL === 'https://finance.automoby.ge') {
        primaryColor = "#235e82"
    } else if(baseFileURL === 'https://crm.aig.com.ge') {
        primaryColor = "#da0429" 
    }



    const options = {
        chart: {
            type: 'bar',
            height: 350,
            animations: {
                enabled: false
            },
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '55%',
                borderRadius: 5,
                endingShape: 'rounded'
            },
        },
        title: {
            text: t('Brandssold'),
        },
        colors: [primaryColor, primaryColor, primaryColor, primaryColor, primaryColor],  
        dataLabels: {
            enabled: true,
            position: 'top',
            style: {
                fontSize: '16px',
                colors: ['#FFF']  
            },
            formatter: function (val) {
                return val;
            }
        },
        stroke: {
            show: true,
            width: 2,
            colors: [primaryColor]
        },
        xaxis: {
            categories: (data && data.makers) ? data.makers.map(maker => maker.MakerName) : []
        },
        
        yaxis: {
            title: {
                text:  t('NumberOfCars')
            },
        },
        fill: {
            opacity: 1
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return val + " " + t('Cars');
                }
            }
        },
        theme: {
            monochrome: {
                enabled: true,
                color: primaryColor,
                shadeIntensity: 0.6
            }
        }
    };

    const series = [{
        name: t('Sales'),
        data: data?.makers?.map(maker => maker.Count) ?? []
        
    }];

    return (
        <ReactApexChart options={options} series={series} type="bar" height={350} />
    );
}

export default SalesChart;
